/**
 * RBAC — the six PazPortal roles, ordered by ascending privilege.
 *
 * `viewer` is the only customer-facing role; the other five are PazNetworks
 * staff and are granted the `is_paznetworks_staff()` RLS bypass. Keep this
 * list in sync with the `role` enum in the database.
 */

export const ROLES = [
  'viewer',
  'support_agent',
  'account_manager',
  'billing_admin',
  'admin',
  'superadmin',
] as const;

export type Role = (typeof ROLES)[number];

/** Internal PazNetworks staff roles (everything except `viewer`). */
export const STAFF_ROLES = [
  'support_agent',
  'account_manager',
  'billing_admin',
  'admin',
  'superadmin',
] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

/** True when `role` is one of the six known roles. */
export function isRole(role: string | null | undefined): role is Role {
  return typeof role === 'string' && (ROLES as readonly string[]).includes(role);
}

/** True when `role` is an internal PazNetworks staff role. */
export function isStaffRole(role: string | null | undefined): role is StaffRole {
  return typeof role === 'string' && (STAFF_ROLES as readonly string[]).includes(role);
}
